import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAugmentedJQuery, IController, IModule, IOnChangesObject, IPromise, IQService, IScope, ITimeoutService,} from "angular";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {UuidGenerator} from "felles/tjenester/UuidGenerator";
import {SaksmalSkjemamodell} from "../../MalmøteTjeneste";
import {varigheter5MinIntervaller} from "felles/stoettefunk/datoer";
import {SakstypeRessurs} from "felles/tjenester/ressurser/SakstypeRessurs";
import {TemaRessurs} from "felles/tjenester/ressurser/TemaRessurs";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {MøteTjeneste} from "web/moduler/møte/MøteTjeneste";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {VarighetMedLabel} from "felles/tjenester/ressurser/SakRessurs";

const css = require('./malsakskjema.scss');

export class MalsakskjemaKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmGruppeMalsakskjema', {
                bindings: {saksmaler: '<', gruppeId: '<'},
                controller: MalsakskjemaKontroller.forInjisering(),
                template: require('./malsakskjema.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$element,
            regNavn.ng.$timeout,
            regNavn.smoothScroll,
            regNavn.ng.$q,
            SakstypeRessurs.regNavn,
            TemaRessurs.regNavn,
            GruppeRessurs.regNavn,
            MøteTjeneste.regNavn,
            UuidGenerator.regNavn,
            regNavn.gettext.gettextCatalog,
            MalsakskjemaKontroller
        ]
    }

    static eventMalsaksskjemaVarighetEndret = "wmMalmoeteSakskjema.eventSaksskjemaVarighetEndret";

    constructor(private $scope: IScope,
                private $element: IAugmentedJQuery,
                private $timeout: ITimeoutService,
                private smoothScroll: smoothScroll,
                private $q: IQService,
                private sakstypeRes: SakstypeRessurs,
                private temaRes: TemaRessurs,
                private gruppeRes: GruppeRessurs,
                private møteTjeneste: MøteTjeneste,
                private uuidGenerator: UuidGenerator,
                private gettextCatalog: gettextCatalog) {
    }

    saksmaler: SaksmalSkjemamodell[]; //settes via bindings/$onChanges
    gruppeId: string; //settes via bindings/$onChanges

    tilleggsdata: MalsaksskjemTilleggsdata;
    pauseSakstype = SaksmalSkjemamodell.pauseSakstype();

    gaaTilNySak() {
        this.scrollTilBunn()
            .then(() => {
                let element = this.$element.find('.wgk-ms-sak:last-child .wgk-ms-tittel input');
                element.focus();
            });

    }

    sakstittelEndret(saksSkjema: SaksmalSkjemamodell) {
        //sørger for at det altid vises en tom sak til slutt i listen
        if (saksSkjema.erTittelAngitt() && _.last(this.saksmaler) == saksSkjema) {
            this.leggTilBlankSkjemaradTilSlutt();
            this.scrollTilBunn();
        }

        //sørger for at det ikke vises mer enn en tom sak i listen
        if (!saksSkjema.erTittelAngitt() && !_.last(this.saksmaler).erTittelAngitt())
            this.fjernSisteSkjemarad();
    }

    slettSak(skjemaSomFjernes: SaksmalSkjemamodell) {
        if (this.saksmaler.length === 1) return;
        _.remove(this.saksmaler, skjema => skjema === skjemaSomFjernes);
    }

    varighetEndret(nyVarighet: number) {
        this.$scope.$emit(MalsakskjemaKontroller.eventMalsaksskjemaVarighetEndret, nyVarighet);
    }

    /** konfig for sakslite ng-sortable */
    ngSortableKonfigForSaksrekkefoelge() {
        return {
            // sørger for at sak som flyttes opptrer som barn av .sls-saksliste i dom-treet
            // i stendenfor barn av body som er default
            // betinger containerPositioning:relative
            containment: '.wgk-ms-saksliste',
            containerPositioning: 'relative'
        };
    }

    $onChanges(changes: IOnChangesObject) {
        if (changes['saksmaler'] && changes['saksmaler'].currentValue)
            this.initSakskjemamodeller();

        if (changes['gruppeId'] && changes['gruppeId'].currentValue)
            this.initTilleggsdata();
    }

    //hjelpemetoder

    private initTilleggsdata(){
        if (this.tilleggsdata) return; //dersom data allerede er initialisert
        this.tilleggsdata = this.malsakSkjemaTilleggsdata(this.gruppeId).tilleggsdata;
    }

    private initSakskjemamodeller() {
        if (_.isEmpty(this.saksmaler) || _.last(this.saksmaler).erTittelAngitt())
            this.leggTilBlankSkjemaradTilSlutt();
    }

    private leggTilBlankSkjemaradTilSlutt() {
        this.saksmaler.push(this.initNySakSkjemaModell());
    }

    private initNySakSkjemaModell(): SaksmalSkjemamodell {
        let saksvarigheter = varigheter5MinIntervaller(this.gettextCatalog);
        return SaksmalSkjemamodell.nyTomSaksmalSkjemamodell(saksvarigheter, this.uuidGenerator);
    }

    private fjernSisteSkjemarad() {
        this.saksmaler.pop();
    }

    private scrollTilBunn(utførEtterScroll = _.noop) {
        const scroll = () =>
            this.smoothScroll(this.$element.find('.scroll-til-bunnen-element')[0], {
                containerId: 'basissideInnhold',
                duration: 500,
                callbackAfter: utførEtterScroll
            });
        //må kjøres async for å få effekt
        return this.$timeout(scroll, 100);
    }

       /** laster MalsaksskjemTilleggsdata, retunerer tilleggsdata samt et promise som resolver når alle asynk kall er ferdig */
       private malsakSkjemaTilleggsdata(eiendeGruppeId: string): {tilleggsdata:MalsaksskjemTilleggsdata, alleDataLastet: IPromise<any>} {
        let saksvarigheter = varigheter5MinIntervaller(this.gettextCatalog);
        let tilleggsdata:MalsaksskjemTilleggsdata = {
            ansvarlige: [], //sette via promise lenger ned
            sakstyper: [],//sette via promise lenger ned
            temaer: [], //sette via promise lenger ned
            aktiveTemaer: [], //sette via promise lenger ned
            arkiverteTemaer: [], //sette via promise lenger ned
            saksvarigheter: saksvarigheter,
            pauseSakstype: SaksmalSkjemamodell.pauseSakstype(),
            inkludertGenerertDokumentValg: this.møteTjeneste.inkluderGenerertDokumentValg()
        };
        const medlemmerPromise = this.gruppeRes.finnTilgjengeligeMedlemmer(eiendeGruppeId).$promise
          .then(medlemmer => tilleggsdata.ansvarlige = medlemmer)
        const sakstyperPromise = this.sakstypeRes.tilgjengeligeSakstyper(eiendeGruppeId).$promise
          .then(sakstyper => tilleggsdata.sakstyper = sakstyper)
        const temaerPromise = this.populerTilleggsdataMedTema(eiendeGruppeId, tilleggsdata);

        return {tilleggsdata: tilleggsdata, alleDataLastet: this.$q.all([medlemmerPromise, sakstyperPromise, temaerPromise])}
    }

    private populerTilleggsdataMedTema(eiendeGruppeId:string, tilleggsdata:SaksskjemTilleggsdata){
        return this.temaRes.alleTema(eiendeGruppeId).$promise
          .then(temaer => {
              tilleggsdata.temaer = temaer;
              tilleggsdata.aktiveTemaer = temaer.filter(tema => !tema.arkivert);
              tilleggsdata.arkiverteTemaer = temaer.filter(tema => tema.arkivert);
          });
    }
}


export interface SaksskjemTilleggsdata {
    ansvarlige: l.GruppeMedlemListeModell[];
    sakstyper: l.SakstypeModell[];
    temaer: l.TemaModell[];
    aktiveTemaer: l.TemaModell[];
    arkiverteTemaer: l.TemaModell[];
    saksvarigheter: VarighetMedLabel[];
    pauseSakstype: l.SakstypeModell;
}

export interface MalsaksskjemTilleggsdata extends SaksskjemTilleggsdata {
    inkludertGenerertDokumentValg: { [verdi: number]: string }
}

